module.exports = __webpack_public_path__ + "static/media/joe-logo.f210e13b.png";